const FirebaseConfig = {
 apiKey: "AIzaSyBwL_t5Sn4Ul1i79YFhys_WNi0taeZmrfE",
    authDomain: "motorsport-admin.firebaseapp.com",
    projectId: "motorsport-admin",
    storageBucket: "motorsport-admin.appspot.com",
    messagingSenderId: "573645846914",
    appId: "1:573645846914:web:c192fd74c3cf3ebb75779b",
    measurementId: "G-JGZCZD61RE"
};

export default FirebaseConfig

